import script from "./client-estimate-submit.vue?vue&type=script&setup=true&lang=js"
export * from "./client-estimate-submit.vue?vue&type=script&setup=true&lang=js"

import "./client-estimate-submit.vue?vue&type=style&index=0&id=3c83c0c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c83c0c4"]])

export default __exports__